/**
 * Triggers a file download without navigating away or opening a new tab.
 * Uses fetch + blob when CORS allows; otherwise a hidden iframe (no main-window redirect).
 */
export async function triggerBrowserDownload(url, suggestedName = "ZillionExchange.apk") {
  if (!url || typeof url !== "string") return;

  let fileName = suggestedName;
  try {
    const pathPart = new URL(url, window.location.href).pathname.split("/").pop();
    if (pathPart && /\.(apk|ipa|dmg|zip)$/i.test(pathPart)) fileName = pathPart;
  } catch {
    /* keep suggestedName */
  }

  try {
    const res = await fetch(url, { method: "GET", mode: "cors", cache: "no-store" });
    if (res.ok) {
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
      return;
    }
  } catch {
    /* CORS or network — try iframe */
  }

  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.display = "none";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.src = url;
  document.body.appendChild(iframe);
  window.setTimeout(() => {
    try {
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    } catch {
      /* ignore */
    }
  }, 120000);
}
